import { Text, TextStyle } from 'react-native';
import { TTextDynamicProps } from './TextDynamic.types';
import { FontFamily } from 'src/constants/font.constants';
import { useDynamicFont } from './useDynamicFont';

type TextDynamicProps = TTextDynamicProps & {
  testID?: string;
};

const TextDynamic = (props: TextDynamicProps) => {
  const {
    fontFamily = FontFamily.Lato,
    fontStyle,
    size,
    alignment,
    color,
    autoSize = false,
    minFontScale = 0.5,
    maxLines,
    style,
    testID = 'text-dynamic',
    ...restProps
  } = props;

  // Build style object from dedicated props
  const dedicatedStyle: TextStyle = {};

  if (size !== undefined) {
    dedicatedStyle.fontSize = size;
  }

  if (alignment !== undefined) {
    dedicatedStyle.textAlign = alignment;
  }

  if (color !== undefined) {
    dedicatedStyle.color = color;
  }

  // Get the font family based on fontFamily and fontStyle
  const dynamicFontStyle = useDynamicFont(fontFamily, fontStyle, style);

  return (
    !!props.children && (
      <Text
        {...restProps}
        style={[dynamicFontStyle, dedicatedStyle, style]}
        adjustsFontSizeToFit={autoSize}
        minimumFontScale={autoSize ? minFontScale : undefined}
        numberOfLines={maxLines}
        testID={testID}
      >
        {props.children}
      </Text>
    )
  );
};

export default TextDynamic;
